import{__assign as r}from'./../../../ext-esm/tslib/tslib.es6.js';import{jsx as o}from"react/jsx-runtime";import{Table as t}from"@material-ui/core";var e=function(e){return o(t,r({},e))};export{e as Table};
